export enum ToggleChatContainerE {
  CHAT = 'chat',
  GROUP = 'group',
  DIALER = 'dialer',
  DEFAULT = 'default',
}
